import React from "react";
import cn from "classnames";
import { noop } from "lib/utils";

import "styles/components/a11y-element.scss";

const A11yElement = ({
  as: Element = "div",
  children,
  className,
  onAction = noop,
  onClick,
  onEnter,
  onArrowLeftDown = noop,
  onArrowRightTop = noop,
  tabIndex = 0,
  ...props
}) => {
  if (typeof onAction === "function") {
    if (!onClick) {
      onClick = onAction;
    } else {
      console.warn(
        `A11yElement: "OnAction is ignored". You cannot use onAction with onClick or onEnter handlers at the same time.`
      );
    }
  }

  const handleKeys = e => {
    switch (e.keyCode) {
      case 13:
        onAction();
        break;
      case 37:
      case 40:
        e.preventDefault();
        onArrowLeftDown();
        break;
      case 38:
      case 39:
        e.preventDefault();
        onArrowRightTop();
        break;
      default:
        return null;
    }
  };

  return (
    <Element
      tabIndex={tabIndex}
      onClick={onClick}
      onKeyDown={e => handleKeys(e)}
      className={cn("otrl-jp__a11y-elem", className)}
      {...props}
    >
      {children}
    </Element>
  );
};

export default A11yElement;
